/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Directive, EventEmitter, HostListener, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {AigiaLoginTotpDialogComponent} from "../aigia-login-totp-dialog/aigia-login-totp-dialog.component";
import {AigiaLoginDialogComponent} from "./aigia-login-dialog.component";
import {TranslateService} from '@ngx-translate/core';

@Directive({
	selector: "[aigia-login-button]",
})

/**
 * todo
 */
export class AigiaLoginDialogDirective {

	@Output() public complete = new EventEmitter<any>();

	/**
	 * todo
	 */
	constructor(
		private matDialog: MatDialog,
		public translate: TranslateService
	) {
	}

	/**
	 * todo
	 */
	private Complete(type: string, value: any): void {
		this.complete.emit({type, value});
	}

	/**
	 * todo
	 */
	@HostListener("click", ["$event.target"])
	public onClick(target: any): void {

		const dialog: MatDialogRef<any> = this.matDialog.open(AigiaLoginDialogComponent, {
			width: "60%",
			minWidth: "320px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				content: {
					title: this.translate.instant('マイページにログインする'),
					description: "",
					username: "",
					password: "",
					code: "",
				},
			},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) {
				if (result.is_2fa) {
					result.content.title = "Enter Code.";
					result.content.description = "Google Authenticator, etc...";
					const info_dialog: MatDialogRef<any> = this.matDialog.open(AigiaLoginTotpDialogComponent, {
						width: "30%",
						minWidth: "320px",
						height: "fit-content",
						data: result,
						disableClose: true,
					});

					info_dialog.afterClosed().subscribe((result: any): void => {

					});
				}
			} else {
				this.Complete("error", result);
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("",result);
			}
		});

	}

}
